import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService } from 'app/services';
import { debounce, toLower } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-tire-storage-info',
  templateUrl: './tire-storage-info.component.html',
  styleUrls: ['./tire-storage-info.component.scss'],
  providers: [DialogService],
})
export class TireStorageInfoComponent implements OnInit {
  @Input() lowerTreadDepthThreshold: string = '';
  @Input() disabledDuplicate: boolean = false;
  @Input() sesonalityOptions: any[] = [];
  @Input() tirePositionOptions: any[] = [];
  @Input('categories')
  set categories(data) {
    if (data && data?.length) {
      this.categoriesList = [...data];
      this.tagsSuggestion = this.helperService.deepCopy(data);
      if (this.size && this.size.brand && this.size.brand.name) {
        const selectedBrand: any[] = this.categoriesList.filter(({ name }) => new RegExp(this.size.brand.name, 'i').test(name));
        if (selectedBrand && selectedBrand.length > 0) {
          this.handleChange(selectedBrand[0], 'brand');
        }
      }
    }
  }
  @Input() isDisabled: boolean = false;
  @Input() tireStorageDisabledTooltip: string = '';
  @Input() isEnhancedTSEnabled: boolean = false;
  @Input() index: number = 0;
  @Input() size: any = {};
  @Input() rimTypes: any[] = [];
  @Input() locations: any[] = [];
  @Input() errors: any = {};
  @Input() estimateOrderStatus: string = '';
  @Input('tire')
  set tire(tire: any) {
    if (!this.focus.title && tire.brand && tire.brand.name && tire.model && (!this.size.title || this.size.title === this.previousTitle)) {
      if (this.size.size) {
        this.size.title = `${tire.brand.name} ${tire.model} ${this.size.size}`;
      } else {
        this.size.title = `${tire.brand.name} ${tire.model}`;
      }
      this.previousTitle = this.size.title;
    }

    this._tire = tire;
  }

  @Output() appDeleteTireStorageSize = new EventEmitter();
  @Output() appUpdateLocations = new EventEmitter();
  @Output() appCreateBrand = new EventEmitter();
  @Output() appOnUpdateItem = new EventEmitter();
  @Output() appDuplicateTireStorageSize = new EventEmitter();

  _tire: any = {};
  previousTitle: string = '';
  focus: any = {};
  initialData: any = {};
  tireType = 'tire';
  locationResults: any[] = [];
  searchQuery: string = '';
  tireHeaderTitle: string = '';
  tagsSuggestion: any[] = [];
  categoriesList: any = [];

  constructor(private helperService: HelperService, private httpService: HTTPService, private dialogService: DialogService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.initialData = this.helperService.deepCopy(this.size);
    this.locationResults = this.helperService.deepCopy(this.locations);

    if (this.isEnhancedTSEnabled) {
      // if (this.size && !this.size.tirePosition) {
      //   this.assignRelevantTirePosition();
      // } else
      // if (this.size && this.size?.tirePosition) {
      //   this.size.tireHeaderTitle = this.getTireHeaderTitle(this.size.tirePosition?.order || 0);
      // }
      if (this.size && this.size?.tirePosition) {
        this.size.tireHeaderTitle = this.getTireHeaderTitle(this.size.tirePosition?.order || 0);
      } else if (this.size && !this.size.tirePosition && this.size?.isManuallyAdded) {
        this.assignRelevantTirePosition();
      }
    }
  }

  assignRelevantTirePosition() {
    if (this._tire && this._tire.tiresInfo && this._tire.tiresInfo.length > 1) {
      let availableTiresPosistions: any[] = [];
      this.tirePositionOptions.forEach((tirePosition: any) => {
        let matchFound: boolean = false;
        this._tire.tiresInfo.forEach((tireInfo: any) => {
          if (tireInfo.tirePosition && tireInfo.tirePosition.value === tirePosition.value) {
            matchFound = true;
          }
        });
        if (!matchFound) {
          availableTiresPosistions.push(tirePosition);
        }
      });
      if (availableTiresPosistions && availableTiresPosistions.length > 0) {
        this.handleChange(availableTiresPosistions[0], 'tirePosition');
      }
    } else {
      this.handleChange(this.tirePositionOptions[this.index], 'tirePosition');
    }
  }

  handleFocus(type: string) {
    this.errors[type] = '';
    this.focus[type] = true;
  }

  handleChange(value: any, type: string, checkTirePosition?: boolean) {
    if (type === 'brand') {
      this.size.brand = { brandId: value?._id, name: value?.name };
      this.errors.brand = '';
    } else if (type !== 'tirePosition') {
      this.size[type] = value;
    } else if (type === 'tirePosition') {
      this.handleFocus('tirePosition');
      if (checkTirePosition) {
        if (value?.value !== this.size[type]?.value) {
          this.chekSwitchTirePositionRequired(value);
        }
      } else {
        this.size[type] = value;
        this.size.tireHeaderTitle = this.getTireHeaderTitle(value.order);
      }
    }
  }

  // handleBlur(type: string) {
  //   if (this.isEnhancedTSEnabled && type === 'treadDepth' && this.size.treadDepth && this.lowerTreadDepthThreshold) {
  //     let parts = this.size.treadDepth.split("/");
  //     this.size.recommendReplacement = parts[0] ?
  //       Number(parts[0]) <= Number(this.lowerTreadDepthThreshold) : false;
  //   } else if (!this.size.treadDepth) {
  //     this.size.recommendReplacement = false;
  //   }
  //   // E.g: 55/32
  //   if (type === 'treadDepth' && this.isEnhancedTSEnabled) {
  //     if ((this.size.treadDepth && this.size.treadDepth < 1) || this.size.treadDepth > 32) {
  //       this.errors.treadDepth = 'Must be between 1 to 32';
  //     }
  //   }

  //   if (this.size.oldTreadDepth) {
  //     const { isValid } = this.helperService.getTreadDepth(this.size.treadDepth);

  //     if (isValid) {
  //       this.size.oldTreadDepth = '';
  //     }
  //   }
  // }


  handleBlurForTreadDepth(type: string) {

    // Validating the treadDepth number block first.
    if (type === 'treadDepth' && this.isEnhancedTSEnabled) {

      // Getting the treadNumber from the treadDepth string first (e.g., "50/32")
      const treadDepthParts = this.size.treadDepth ? this.size.treadDepth.split("/") : [];
      const treadNumber = treadDepthParts[0] ? Number(treadDepthParts[0]) : null;

      if (treadNumber !== null) {

        // Then check if the treadNumber is greater than or equal to 32 and throw errors accordingly
        if (treadNumber < 1 || treadNumber > 32) {
          this.errors.treadDepth = 'Must be between 1 and 32';
        } else {
          this.errors.treadDepth = null;
        }
      }
      // else {
      //   this.errors.treadDepth = 'Invalid tread depth format';
      // }
    }

    if (this.isEnhancedTSEnabled && type === 'treadDepth' && this.size.treadDepth && this.lowerTreadDepthThreshold) {
      const parts = this.size.treadDepth.split("/");
      this.size.recommendReplacement = parts[0]
        ? Number(parts[0]) <= Number(this.lowerTreadDepthThreshold)
        : false;
    } else if (!this.size.treadDepth) {
      this.size.recommendReplacement = false;
    }

    if (this.size.oldTreadDepth) {
      const { isValid } = this.helperService.getTreadDepth(this.size.treadDepth);

      if (isValid) {
        this.size.oldTreadDepth = '';
      }
    }
  }


  chekSwitchTirePositionRequired(value: any) {
    if (this._tire?.tiresInfo?.length > 1) {
      let matchFoundIndex = -1;
      let objectInfo: any = {};
      this._tire.tiresInfo.forEach((tireInfo: any, index: number) => {
        if (tireInfo.tirePosition?.value === value.value) {
          matchFoundIndex = index;
          objectInfo.curentTirePosition = this.size.tirePosition;
          objectInfo.matchFoundIndex = index;
          objectInfo.changedTirePosition = value;
        }
      });

      if (matchFoundIndex > -1) {
        this.openSwitchConfirmationDialog(objectInfo);
      } else {
        this.handleChange(value, 'tirePosition');
      }
    } else {
      this.handleChange(value, 'tirePosition');
    }
  }

  openSwitchConfirmationDialog(data: any) {
    let title = `Switch Tire Positions?`;
    let message = `The position ${data.changedTirePosition?.name} is already assigned to another tire. Would you like to switch the positions of ${data.changedTirePosition?.name} and ${data.curentTirePosition?.name}?`;

    if (!data.curentTirePosition?.name) {
      title = 'Tire Position';
      message = `The position ${data.changedTirePosition?.name} is already assigned to another tire.`;
    }

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: title,
        message: message,
        button: {
          success: data.curentTirePosition?.name ? { title: 'Switch Positions' } : null,
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this._tire.tiresInfo[data.matchFoundIndex].tirePosition = this.helperService.deepCopy(data.curentTirePosition);
        this._tire.tiresInfo[data.matchFoundIndex].tireHeaderTitle = this.getTireHeaderTitle(data.curentTirePosition.order);
        this.handleChange(data.changedTirePosition, 'tirePosition');
      } else {
        this.size.tirePosition = '';
        this.cdr.detectChanges();
        this.handleChange(data.curentTirePosition, 'tirePosition');
      }
      onClose.unsubscribe();
    });
  }

  handleDeleteSize() {
    // if (this.tire.isInStorage) return;
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete tire storage`,
        message: `Are you sure you want to delete this tire storage?`,
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.appDeleteTireStorageSize.emit(this.index);
      }
      onClose.unsubscribe();
    });
  }

  handleRimTypeSave({ name }) {
    this.httpService.createTag({ name, type: 'rimType' }).then(
      (tag) => {
        this.rimTypes.push(tag);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onStorageLocationSearch(query: string = '') {
    this.searchQuery = query;
    this.searchLocation();
  }

  searchLocation = debounce(() => {
    this.httpService.getTireStorageLocation(this.searchQuery).then(
      (locatons: any[]) => {
        this.locationResults = locatons.map(({ _id, title }) => ({ _id, locationId: _id, name: title }));
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }, 600);

  onStorageLocationUpdate({ name, color, _id }) {
    this.httpService.updateTireStorageLocation({ title: name, color, locationId: _id }).then(
      (locaton: any) => {
        if (locaton) {
          if (this.size && this.size.storageLocation && this.size.storageLocation.locationId === locaton._id) {
            this.size.storageLocation.name = locaton.title;
            this.size.storageLocation.title = locaton.title;
          }
        }
        this.searchLocation();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onStorageLocationSave(e) {
    this.httpService.createTireStorageLocation({ title: e.name }).then(
      (data: any) => {
        if (data) {
          this.handleChange({ locationId: data._id, name: data.title }, 'storageLocation');
          this.locations = [...this.locations, { locationId: data._id, name: data.title }];
          this.locationResults.push({ locationId: data._id, name: data.title });
          this.appUpdateLocations.emit(this.locations);
        }
      },
      (err: any) => {
        if (err === 'Location already exists') {
          if (this.locations && this.locations.length) {
            const location: any = this.locations.find((locItem: any) => locItem.name && toLower(locItem.name) === toLower(e.name));
            if (location && location.locationId) {
              this.handleChange({ locationId: location.locationId, name: location.name }, 'storageLocation');
            }
          }
        }
        this.helperService.showToaster('error', err);
      }
    );
  }

  onStorageLocationClear() {
    this.onStorageLocationSearch('');
  }

  getTireHeaderTitle(index: number): string {
    let tireHeaderTitle: string = '';
    switch (index) {
      case 0: {
        tireHeaderTitle = 'Front left (FL)';
        break;
      }
      case 1: {
        tireHeaderTitle = 'Front right (FR)';
        break;
      }
      case 2: {
        tireHeaderTitle = 'Rear left (RL)';
        break;
      }
      case 3: {
        tireHeaderTitle = 'Rear right (RR)';
        break;
      }
      case 4: {
        tireHeaderTitle = 'Spare 1';
        break;
      }
      case 5: {
        tireHeaderTitle = 'Spare 2';
        break;
      }
    }

    return tireHeaderTitle;
  }

  handleCreateBrand(data: any) {
    this.appCreateBrand.emit(data);
  }

  onUpdateItem(data: any, type: string) {
    this.appOnUpdateItem.emit({ data, type });
  }

  handleClear() {
    this.tagsSuggestion = [...this.categories];
  }

  handleDuplicateSize(data: any) {
    // if (this.tire.isInStorage) return;
    const obj: any = this.helperService.deepCopy(data);
    if (obj.tirePosition) {
      obj.tirePosition = '';
    }
    this.appDuplicateTireStorageSize.emit(obj);
  }

  handleTagSearch(query: string) {
    if (!query) {
      return;
    }

    this.tagsSuggestion = this.categoriesList.filter(({ name }) => new RegExp(query, 'i').test(name));
  }
}
